module.exports = __webpack_public_path__ + "img/1282111087.3d11bf93.jpg";